import {
  FileText,
  Calendar,
  Landmark,
  Users,
  UsersRound,
  MapPin,
  Atom,
  Link as LinkIcon,
  History,
  Book,
  Proportions,
  Info,
  Mail,
  Home,
  Handshake,
  HeartHandshake,
  SquareStack,
  Wrench,
  Trophy,
  Megaphone,
  Briefcase,
  Mic,
} from 'lucide-react'

export type SiteSection = {
  href: string
  label: string
  icon: React.ComponentType<{ className?: string }>
}

export const siteSections: SiteSection[] = [
  { href: '/', label: 'Home', icon: Home },
  { href: '/models', label: 'Models', icon: Atom },
  { href: '/voice-models', label: 'Voice Models', icon: Mic },
  {
    href: '/models/leaderboard',
    label: 'LLM Leaderboard',
    icon: Trophy,
  },
  {
    href: '/voice-models/leaderboard',
    label: 'Voice Leaderboard',
    icon: Trophy,
  },
  { href: '/milestones', label: 'Milestones', icon: Calendar },
  { href: '/benchmarks', label: 'Benchmarks', icon: Proportions },
  { href: '/assistants', label: 'Assistants', icon: Users },
  { href: '/companies', label: 'Companies', icon: Landmark },
  { href: '/people', label: 'People', icon: UsersRound },
  { href: '/tools', label: 'Tools', icon: Wrench },
  { href: '/guides', label: 'Guides', icon: Book },
  { href: '/updates', label: 'Updates', icon: History },
  { href: '/mcp', label: 'MCP', icon: SquareStack },
  { href: '/glossary', label: 'Glossary', icon: Book },
  { href: '/about', label: 'About', icon: Info },
  { href: '/contact', label: 'Contact', icon: Mail },
  { href: '/contribute', label: 'Contribute', icon: Handshake },
  { href: '/advertising', label: 'Advertising', icon: Megaphone },
  { href: '/consulting', label: 'Consulting', icon: Briefcase },
  { href: '/jobs', label: 'Jobs Board', icon: FileText },
  { href: '/ai-history', label: 'AI History', icon: History },
  { href: '/links', label: 'Links', icon: LinkIcon },
  {
    href: 'https://buy.polar.sh/polar_cl_INfm97n1Kq1FKgZ3d81qg8B7dFZMHv5a1IKPz2SinL3',
    label: 'Support',
    icon: HeartHandshake,
  },
]
